export const ckEditorConfig = {
  language: 'de',
  toolbar: [
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    '|',
    'outdent',
    'indent',
    '|',
    'blockQuote',
    'insertImage',
    'undo',
    'redo',
  ],
};
